import type React from "react";
import { useMount } from "app/custom-hooks/useMount";
import { setCacheToken } from "app/pages/sales-intelligence/sub-modules/management/store/actions/common";
import { selectCacheToken } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/common";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

export const withCacheToken = <T extends Record<string, unknown>>(Component: React.ComponentType<T>) => {
    return function(props: T) {
        const cacheToken: string = useSelector(selectCacheToken);
        const dispatch = useDispatch();

        useMount(() => {
            if (!cacheToken.length) {
                dispatch(setCacheToken(uuidv4()));
            }
        });

        return <Component {...props} />;
    };
};
